import React from 'react';

const DashboardTodaysDeviceStatus = ({ handleModalShow, getcsvFileName, siteId, deviceStatus }) => {
  // Find the widget with WidgetID 10, 11, 12, 13, 14, etc. and merge WidgetData
  const allDeviceData = (deviceStatus || [])
    .map(widget => widget.WidgetData || {})
    .reduce((acc, curr) => {
      Object.entries(curr).forEach(([deviceType, statusObj]) => {
        if (!acc[deviceType]) acc[deviceType] = {};
        Object.entries(statusObj).forEach(([status, count]) => {
          acc[deviceType][status] = (acc[deviceType][status] || 0) + count;
        });
      });
      return acc;
    }, {});

  // Map deviceType to Datapoints for passing to handleModalShow
  // Map deviceType to Datapoints for passing to handleModalShow
  const deviceTypeToDatapoints = {};
    (deviceStatus || []).forEach(widget => {
    if (widget.Datapoints && widget.Datapoints.Interfacetypename) {
      // Map Interfacetypename(s)
      widget.Datapoints.Interfacetypename.forEach(type => {
        deviceTypeToDatapoints[type] = widget.Datapoints;
      });
      // Map WidgetData keys (e.g., "ACS Controller", "Camera") to Datapoints
      if (widget.WidgetData) {
        Object.keys(widget.WidgetData).forEach(type => {
          deviceTypeToDatapoints[type] = widget.Datapoints;
        });
      }
    }
    });

  console.log({deviceTypeToDatapoints})

  const deviceTypes = Object.keys(allDeviceData);

  return (
    <div className="Devicecontainer">
      {deviceTypes.length > 0 ? (
        deviceTypes.map((deviceType, idx) => (
          <div className="box" key={idx}>
            <div className="title">{deviceType}</div>
            <div className="content">
              {Object.entries(allDeviceData[deviceType]).map(([status, count], i) => (
                <div className="column" key={i}>
                  <span>{status}</span>
                  <h6
                    style={{ cursor: handleModalShow ? 'pointer' : 'default' }}
                    onClick={() =>{
                      handleModalShow({ [deviceType]: status },'DeviceStatus',null,{ SiteID: [siteId] },getcsvFileName(deviceType, status),deviceType )
                    }}
                  >
                    {count.toString().padStart(2, "0")}
                  </h6>
                </div>
              ))}
            </div>
          </div>
        ))
      ) : (
        <p className="no-device-message">No device available</p>
      )}
    </div>
  );
};

export default DashboardTodaysDeviceStatus;